var moduleMap = {
	"./Authenticate": () => {
		return Promise.all(/* __federation_expose_Authenticate */[__webpack_require__.e(108), __webpack_require__.e(895)]).then(() => (() => ((__webpack_require__(526)))));
	},
	"./CheckSession": () => {
		return Promise.all(/* __federation_expose_CheckSession */[__webpack_require__.e(108), __webpack_require__.e(604)]).then(() => (() => ((__webpack_require__(856)))));
	},
	"./FederateLogout": () => {
		return Promise.all(/* __federation_expose_FederateLogout */[__webpack_require__.e(108), __webpack_require__.e(810)]).then(() => (() => ((__webpack_require__(892)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});